export const style = {
  container: {
    alignItems: 'flexStart',
    flexWrap: 'wrap',
    rowGap: '10',
    columnGap: '10',
  },
  spinner: {
    color: 'gray.500',
  },
};
